import React from 'react';
import { makeStyles } from '@material-ui/core';

import { FIRST_LAST } from 'selectors/formatName/selector';
import UserBadge from 'components/threepp/UserBadge/UserBadge';
import { toFormattedLocalDate } from 'utils/dateTime/converter';

const useStyles = makeStyles(theme => ({
  comment: {
    marginLeft: theme.whitespace.more,
    width: '95%'
  },
  commentHeader: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  commentUser: {
    fontWeight: 'bold',
    color: theme.palette.textColor,
    fontSize: '14px'
  },
  commentedAt: {
    color: '#616161',
    fontSize: '12px'
  }
}));

const CommentHeader = props => {
  const { actions, children, commentUser, lastUpdated } = props;
  const { first_name: firstName, last_name: lastName, email } = commentUser;

  const classes = useStyles();
  const badgeStyle = { height: '30px', width: '30px' };

  return (
    <>
      <UserBadge user={{ firstName, lastName, email }} format={FIRST_LAST} badgeStyle={badgeStyle} noName />
      <div className={classes.comment}>
        <div className={classes.commentHeader}>
          <div>
            <div className={classes.commentUser}>
              {firstName} {lastName}
            </div>
            <div className={classes.commentedAt}>{toFormattedLocalDate(lastUpdated, 'MM/DD/YYYY')}</div>
          </div>
          {actions}
        </div>
        {children}
      </div>
    </>
  );
};

export default CommentHeader;
